export default __webpack_public_path__ + "static/media/authbg.5c61c316.jpg";